import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-247ee048"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://bouwrisk.nl",
  target: "_blank"
}, "Bouwrisk B.V.", -1))
const _hoisted_3 = { class: "footer-right" }


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileFooter',
  setup(__props) {

const appVersion = process.env.VUE_APP_VERSION

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_divider),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(" Copyright © " + _toDisplayString(new Date().getFullYear()) + " - ", 1),
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, " v" + _toDisplayString(_unref(appVersion)), 1)
    ])
  ], 64))
}
}

})